export function dashify(val) {
  return val.replace(/([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})/, '$1-$2-$3-$4-$5');
}

export const guid = () => {
  const id = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    // eslint-disable-next-line
    const r = Math.random() *16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });

  return id;
};

export function xor(str, key) {
  if (!str || !key) {
    return null;
  }

  return _.reduce(_.zip(str.split(''), key.split('')), function (acc, [a, b]) {
    a = parseInt(a, 16);
    b = parseInt(b, 16);

    if (!isNaN(a) && !isNaN(b)) {
      return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
    }
    return `${acc}-`;
  }, '');
}



// WEBPACK FOOTER //
// ./src/shared/utils/guid.js